import axiosInstance from "../../api/axiosInstance";
import { jwtDecode } from "jwt-decode";
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

const AdminPrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAutheticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("adminToken");

      if (!token) {
        setIsAutheticated(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("adminToken");
          setIsAutheticated(false);
        } else {
          setIsAutheticated(decodedToken.role === "admin");
        }
      } catch (error) {
        console.error("Invalid or expired token", error);
        localStorage.removeItem("adminToken");
        setIsAutheticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <div className="text-white text-center mt-10">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/admin/auth/login" />;
};

export default AdminPrivateRoute;
